export default {
    actions: {
        Logout(ctx, data) {
            axios
                .post(data.path + '/logout',{}, {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: 'Bearer ' + localStorage.getItem('access_token')
                    }
                })
                .then(response => {
                    localStorage.removeItem('access_token');
                    localStorage.removeItem('refresh_token');
                    localStorage.removeItem('user');
                    document.cookie = "user_email= ; expires = Thu, 01 Jan 1970 00:00:00 GMT"
                    ctx.commit('updateIsAuthStatus');
                    ctx.commit('updateAuthUser', null);
                    location.href = `/${data.lang}/login`
                })
        }
    },
    mutations: {},
    state: {},
    getters: {}
}
